import React from 'react';
import { Star, Check } from 'lucide-react';

/**
 * ReviewCard - Shared review card component
 * Flat design style used in /host and /experience pages
 */
const ReviewCard = ({ review }) => {
  if (!review) return null;

  // Format date
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('en-US', {
      month: 'short',
      year: 'numeric'
    });
  };

  return (
    <div className="bg-gray-50 rounded-xl p-5">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          {review.customerAvatar ? (
            <img 
              src={review.customerAvatar} 
              alt={review.customerName}
              className="w-10 h-10 rounded-full object-cover flex-shrink-0"
            />
          ) : (
            <div className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center flex-shrink-0">
              <span className="text-white font-medium text-sm">
                {review.customerName?.charAt(0)?.toUpperCase() || 'G'}
              </span>
            </div>
          )}
          <p className="font-medium text-gray-900 text-sm">
            {review.customerName || 'Guest'}
          </p>
        </div>
        <div className="flex items-center gap-0.5">
          {[...Array(5)].map((_, i) => (
            <Star 
              key={i}
              className={`w-3.5 h-3.5 ${i < review.rating ? 'text-amber-400 fill-amber-400' : 'text-gray-300'}`} 
            />
          ))}
        </div>
      </div>
      {review.title && (
        <p className="font-medium text-gray-900 mb-1 text-sm">{review.title}</p>
      )}
      {review.comment && (
        <p className="text-gray-600 text-sm line-clamp-4">{review.comment}</p>
      )}
      {review.ownerResponse && (
        <div className="mt-3 pt-3 border-t border-gray-200">
          <p className="text-xs font-medium text-gray-500 mb-1">Response from owner</p>
          <p className="text-sm text-gray-600 line-clamp-2">{review.ownerResponse}</p>
        </div>
      )}
      {/* Footer: timestamp left, verified right */}
      <div className="flex items-center justify-between mt-3">
        <span className="text-xs text-gray-400">
          {formatDate(review.createdAt)}
        </span>
        {review.isVerified && (
          <span className="text-xs text-blue-600 flex items-center gap-1">
            <Check className="w-3 h-3" />
            Verified trip
          </span>
        )}
      </div>
    </div>
  );
};

export default ReviewCard;
